import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";

import { BillDetailsInterface } from '../../Models/Billing/Billing';

import { AssetImages } from '../../Constants/Assets';
import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

import BillDetails from './BillDetails';
import ItemDetails from './ItemDetails';
import AmountDetails from './AmountDetails';

const PrintBillContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: #FFFFFF !important;
    position: fixed;
    width: -webkit-fill-available;
    z-index: -1;
    padding: 70px;
    // position: absolute;
    // z-index: 99999;

    .appLogo {
        width: 27%;
    }

    .companyName {
        font-size: 30px !important;
        font-weight: 600;
        text-transform: uppercase;
        place-self: center;
        color: #495057 !important;
        margin: 0px 0px 15px 0px;
    }

    .companyAddress, .companyContact {
        font-size: 25px !important;
        place-self: center;
        color: #495057 !important;
    }

    .invoiceTitleText {
        font-size: 45px !important;
        font-weight: 600;
        text-transform: uppercase;
        place-self: center;
        margin: 20px 0px 10px 0px;
        color: #495057 !important;
    }

    .bDetails {
        display: grid !important;
        grid-template-columns: 1fr 1fr !important;
        gap: 30px;
        margin: 0px !important;

        .detailFieldsContainer {
            width: 100%;
            border: 2px solid #000000;
            padding: 20px;
            height: -webkit-fill-available;
            align-content: start;

            .detailFieldHeader, .colon, .detailFieldvalue {
                font-size: 25px;
                text-transform: uppercase;
                color: #212529 !important;

                .requiredText {
                    display: none;
                }
            }

            .pltlinkBtn {
                pointer-events: none !important;
            }

            .span3Item, .pltlinkBtn {
                grid-column: span 3;
            }
        }
    }

    .invoiceDetailsContainer {
        text-align: left !important;
        margin: 70px 0px 0px 0px;

        .itemHeaderName, .itemValue {
            font-size: 25px;
            color: #212529 !important;
        }

        .itemValueContainer {
            .itemValueName, .colon, .valueItem {
                font-size: 25px;
                color: #212529 !important;

                .requiredText {
                    display: none;
                }
            }  
        }

        .divider {
            border: solid 1px #000000 !important;

            &:last-of-type {
                margin: 120px 0px 0px 0px;
            }
        }

        .amountDetailsContainer {
            width: unset !important;
            .remarksFieldName, .remarksValue, .paymentDetailsItem {
                font-size: 25px !important;
                color: #212529 !important;
            }

            .amountDetailsItemContainer {
                .detailFieldHeader, .detailFieldvalue {
                    font-size: 25px !important;
                    color: #212529 !important;
                }

                .detailFieldHeader {
                    margin: 0px 40px 0px 0px;
                }

                .outstandingBalance {
                    color: #f06548 !important;
                }
            }

            hr {
                border: solid 1px #000000 !important;
            }
        }

        &:last-of-type {
            margin: 0px 0px 0px 0px;
        }
    }

    .thisIsGeneratedInvoice {
        text-align: left !important;
        margin: 120px 0px 0px 0px;
        font-size: 20px !important;
        color: #878a99 !important;
    }    
`;

export default function PrintBill(props: BillDetailsInterface) {
    // Variables
    let {
        previewData,
        printBillRef,
    } = props;

    // Use States

    //Variables
    
    //Event Handlers
    return <PrintBillContainer ref={printBillRef} id="printBillContainer">
        <img className="appLogo" src={AssetImages.WEB_APP_LOGO} />
        <Typography className="companyName">{StaticDisplayText.COMPANY_NAME} ({StaticDisplayText.COMPANY_REGISTRATION_NO})</Typography>
        <Typography className="companyAddress">{StaticDisplayText.COMPANY_ADDRESS}</Typography>
        <Typography className="companyContact">Tel: {StaticDisplayText.COMPANY_CONTACT}</Typography>

        <Typography className="invoiceTitleText">Invoice</Typography>

        <BillDetails {...props} />
        <ItemDetails {...props} />
        <AmountDetails {...props} />

        <Typography className="thisIsGeneratedInvoice">This is a computer-generated invoice which does not required a signature.</Typography>
    </PrintBillContainer>
}
